import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';
import { User, ShopCartItem } from '../../../../models';

interface EmployeeDetailProps {
  user: User;
  shopItem: ShopCartItem;
  quantity: number;
}

function EmployeeDetail({ user, shopItem, quantity }: EmployeeDetailProps) {
  return (
    <div className="w-full flex justify-between mt-3 items-center h-10 pl-2">
      <span>
        {user?.firstName} {user?.lastName}
      </span>

      <div className="flex flex-row h-10  rounded-lg relative bg-transparent mt-1">
        <span className=" flex justify-center  focus:outline-none text-center w-full font-semibold text-md hover:text-black focus:text-black  md:text-base cursor-default items-center text-neutral-cold-400 outline-none">
          <span className="text-purple-300 font-semibold">
            ${formatCurrency(shopItem.price)}
          </span>{' '}
          <span className="ml-1"> x {quantity ?? 1}</span>
          <span className="text-purple-300 font-semibold">
            = ${formatCurrency(shopItem.price * (quantity ?? 1))}
          </span>
        </span>
      </div>
    </div>
  );
}

export default EmployeeDetail;
